module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACDSURBVDiNtZPJDYAwDAQXaGzphE5YKmPphFL4gMSRwwjhXw6PJ4kD/BGSFN3bJpIJYJQ0RwBNwWDch70k5wBdatK2STYACGAgudhewwYnEwI4jpI0KQIikCqgBnm8QgB2MagC7tXv658vMWuw90IxOWvwppEegJO2AUyl5Gy8+UyfYwOWgT/TaLiJqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/arrow.png
// module id = uawv
// module chunks = 0